import cn from 'classnames';
import React from 'react';
import {Route} from 'react-router-dom';

import Toaster from '@/components/Toaster/Toaster';
import appConfig from '@/config/appConfig.typed';
import domIdentifiers from '@/consts/app/domIdentifiers';
import useHistoryScrollTop from '@/hooks/useHistoryScrollTop';
import rtlService from '@/services/app/rtlService';
import userBrowserService from '@/services/user/userBrowserService';
import TermsOfUsePopup from '@/views/Tnc/TermsOfUsePopup/TermsOfUsePopup';

import LoaderGlobal from '../LoaderGlobal/LoaderGlobal';
import ModalsRoot from '../Modals/ModalsRoot';
import useTncPageRedirection from './hooks/useTncPageRedirection';
import Logs from './Logs/Logs';

const AppLayout = ({component: Component, path, exact, strict}) => {
    const isTouchSupported = userBrowserService.isTouchSupported();
    const isRTLEnabled = rtlService.isRtlEnabled();

    useHistoryScrollTop();
    useTncPageRedirection();

    return (
        <Route
            path={path}
            exact={exact}
            strict={strict}
            render={(matchProps) => (
                <div
                    dir={isRTLEnabled ? 'rtl' : 'ltr'}
                    className={cn(domIdentifiers.APP_CLASSNAME, {
                        touch: isTouchSupported,
                        'ica-standalone': userBrowserService.isInStandaloneMode(),
                        'ica-standalone-with-static-top-bar': userBrowserService.isStandaloneWithStaticTopBar(),
                    })}
                >
                    <div className='relative flex min-h-screen flex-col items-center bg-romance font-iqos ml:bg-secondary'>
                        <Toaster />
                        <TermsOfUsePopup />
                        <div
                            className={cn(
                                'flex w-full flex-1 flex-col',
                                domIdentifiers.COMPONENTS_CONTAINER_CLASS_NAME
                            )}
                        >
                            <div className='page-content flex flex-1 justify-center'>
                                <Component {...matchProps} />
                            </div>
                        </div>
                        <LoaderGlobal />
                        <ModalsRoot />
                        {appConfig.getIsDebug() && <Logs />}
                    </div>
                </div>
            )}
        />
    );
};

export default AppLayout;
